import { Grid, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';

import MuiDialog from 'components/MuiDialog';
import {
  SurveyDialogProps,
  TECMOCareDefaultValues,
} from 'routes/Main/Survey/type';
import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';

import CommonPatientInfo from '../../components/CommonPatientInfo';

import TreatmentPlace from './TreatmentPlace';
import TreatmentReasone from './TreatmentReasone';
import ReasoneVV from './ReasoneVV';
import Summation from './Summation';

import { updateECMO, updateSafety } from 'apis/survey';
import Inhibition from './Inhibition';
import SpecialReasone from './SpecialReasone';

const ECMO = (props: SurveyDialogProps<TECMOCareDefaultValues>) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();

  const { handleSubmit, register, getValues, setValue, watch } = useForm({
    defaultValues,
  });

  const onSubmit = (data: TECMOCareDefaultValues) => {
    const {
      treatment_place,
      treatment_reason,
      reason_vv_ecmo,
      summation,
      inhibition_check,

      inhibition1,
      inhibition2,
      inhibition3,
      inhibition4,
      inhibition5,
      inhibition6,
      inhibition7,
      inhibition8,
      inhibition9,
      inhibition10,
      inhibition11,

      special_reason,
    } = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      ecmo_info_survey: {
        treatment_place: {
          ...treatment_place,
        },
        treatment_reason: {
          ...treatment_reason,

          indications: JSON.stringify(treatment_reason.indications),
          va_arrest: JSON.stringify(treatment_reason.va_arrest),
          va_arrest_lvad: JSON.stringify(treatment_reason.va_arrest_lvad),
        },
        reason_vv_ecmo,
        summation,

        inhibition_check: JSON.stringify(inhibition_check),

        inhibition1,
        inhibition2,
        inhibition3,
        inhibition4,
        inhibition5,
        inhibition6,
        inhibition7,
        inhibition8,
        inhibition9,
        inhibition10,
        inhibition11,

        special_reason,
      },
    };

    updateECMO(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);

        onUpdateIsSave(true);
        onSuccess('저장되었습니다');
      })
      .catch(e => onFail('저장에 실패하였습니다', e));
  };

  const formProps = {
    disabled,
    watch,
    register,
    getValues,
    setValue,
    onSuccess,
    onRequired,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Grid
        container
        wrap="wrap"
        rowSpacing={5}
        columnSpacing={3}
        sx={{ py: 5, px: 1 }}
      >
        <Typography
          sx={{
            margin: '40px auto 0px auto',
            fontWeight: '700',
            fontSize: '16px',
            textAlign: 'center',
          }}
        >
          체외순환막형산화요법 (ExtraCorporeal Membrane Oxygenation, ECMO)
          기록지
        </Typography>
        <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
        <TreatmentPlace {...formProps} />
        <TreatmentReasone {...formProps} />
        <ReasoneVV {...formProps} />
        <Summation {...formProps} />
        <Inhibition {...formProps} />
        <SpecialReasone {...formProps} />
      </Grid>
    </MuiDialog.SurveyForm>
  );
};

export default ECMO;
